import { AltNeu, Bodenform, ForstAdresse, Geologie, punktartBeschreibung, punktartDisplayLabel, stfgString, SubstratZeile } from "src/app/data-model";

// Re-export generischer Teile aus Library für Abwärtskompatibilität
export {
	decodeHTML,
	equals, notequals, lessOrEqual, greaterOrEqual, liesBetween,
	stringIsEmpty, stringIsNotEmpty, stringContains, stringDoesNotContain,
	numberIsEmpty, numberIsNotEmpty,
	dateEquals, dateNotequals, dateLessOrEqual, dateGreaterOrEqual, dateLiesBetween,
	anyOf,
	Operators,
	bounds_checkout_filter, design_filter,
	Condition, ICondition, ConditionExpression, ExpressionType, IConditionExpression
} from '@luzula/luzula-lib';

import { anyOf, Condition } from '@luzula/luzula-lib';

// Domänen-spezifische Konverter
export const forstadresseToString = function(a: ForstAdresse) { return `${a.abteilung}${a.unterabteilung}${a.teilflaeche}`; };
export const geologieToString = function(g: Geologie) { let s = ''; if (g.oben) s += `${g.oben}`; if (g.trenner) s += `${g.trenner}`; if(g.unten) s+=`${g.unten}`; return s; };
export const stringToNumber = function(s: string) { return parseInt(s); };

// Punktart-Typ normalisieren: tolerant gegen BEIDE Datenformate, weil die
// v15→v16-Migration lazy laeuft und Alt- ("6_Tiefbohrung") wie Neu-Format ("6")
// gleichzeitig im Bestand liegen. Liefert die reine Nummer als String, sodass ein
// Filter auf "6" auch noch nicht migrierte Alt-Punkte findet ("6" === "6").
// MUSS self-contained sein (wird via .toString() serialisiert + in der generierten
// Filterfunktion ge-evalt → nur parseInt/String/isNaN, keine Modul-Referenzen).
export const punktartTypeNormalize = function(t: string) { const n = parseInt(String(t == null ? '' : t), 10); return isNaN(n) ? '' : String(n); };
export const altNeuConverter = function(an: AltNeu<string|number>|undefined) { return !(an?.neu == null) ? an.neu : an?.alt; };

export const hbfToString = function(b: Bodenform) {
	let result = '';
	if (!b || !b.bf) return result;
	for (let i = 0; i < b.bf.length; ++i) {
		const bf = b.bf[i];
		if (i > 0) result += ' ' + bf.trenner + ' ' + bf.hbf;
		else result += bf.hbf;
	}
	if (b.suffix) result += (result.length > 0 ? ' ' : '') + b.suffix;
	return result;
}

export const fbfToString = function(b: Bodenform) {
	let result = '';
	if (!b || !b.bf) return result;
	for (let i = 0; i < b.bf.length; ++i) {
		const bf = b.bf[i];
		if (i > 0) result += ' ' + bf.trenner + ' ' + bf.fbf;
		else result += bf.fbf;
	}
	if (b.suffix) result += (result.length > 0 ? ' ' : '') + b.suffix;
	return result;
}

// Domänen-spezifische anyOf-Varianten
export const anyOfBaumarten = function(a: any[], func: (val: number|string, ...args: (number|string)[]) => boolean, cfunc?: any, ...args: (number|string)[]) { if (typeof a === 'string') return func(cfunc?cfunc(a):a,...args); return anyOf(a, func, cfunc, ...args); };
export const anyOfVegetationen = function(a: any[], func: (val: number|string, ...args: (number|string)[]) => boolean, cfunc?: any, ...args: (number|string)[]) {
	if(a==null) return false;
	for (let i=0; i < a.length; ++i) {
		const auf = a[i];
		if(!(auf==null)&&!(auf.vegetation==null)&&func(cfunc?cfunc(auf.vegetation):auf.vegetation,...args)) return true;
		if (!auf.vegetationen) continue;
		for (let j=0; j < auf.vegetationen.length; ++j) {
			const el = auf.vegetationen[j];
			if(!(el==null)&&!(el.vegetation==null)&&func(cfunc?cfunc(el.vegetation):el.vegetation,...args)) return true;
		}
	}
	return false;
};

export const anyOfHorizonte = function(a: any[], func: (val: number|string, ...args: (number|string)[]) => boolean, cfunc?: any, ...args: (number|string)[]) {
	if(a==null) return false;
	for (let i=0; i < a.length; ++i) {
		const hor = a[i];
		if(hor == null || !hor.horizonte) continue;
		for (let j=0; j < hor.horizonte.length; ++j) {
			const h=hor.horizonte[j];
			if(!(h==null)&&func(cfunc?cfunc(h):h,...args)) return true;
		}
	}
	return false;
};

export const anyOfSubstrate = function(a: any[], func: (val: number|string, ...args: (number|string)[]) => boolean, cfunc?: any, ...args: (number|string)[]) {
	if(a==null) return false;
	for (let i=0; i<a.length; ++i) {
		const s=a[i];
		if(!(s==null)&&func(cfunc?cfunc(s):s,...args)) return true;
	}
	return false;
};
export const substratToName = function(s: SubstratZeile) { return s!=null ? s.substrat : ''; };
export const substratToHumusgehalt = function(s: SubstratZeile) { return s!=null ? s.humusgehalt : ''; };
export const substratToLagerungsdichte = function(s: SubstratZeile) { return s!=null ? s.lagerungsdichte : ''; };
export const substratToFestigkeit = function(s: SubstratZeile) { return s!=null ? s.festigkeit : ''; };
export const substratToSkelettgehalt = function(s: SubstratZeile) { return s!=null ? s.skelettgehalt : ''; };
export const substratToKarbonatgehalt = function(s: SubstratZeile) { return s!=null ? s.karbonatgehalt : ''; };
export const substratToNWSK = function(s: SubstratZeile) { return s!=null ? s.nWsk : ''; };

export const anyOfProjects = function(a: any[], func: (val: number|string, ...args: (number|string)[]) => boolean, cfunc?: any, ...args: (number|string)[]) {
	if(a==null) return false;
	for (let i=0; i < a.length; ++i) {
		const p = a[i];
		if(!(p==null)&&!(p.name==null)&&func(cfunc?cfunc(p.name):p.name,...args)) return true;
	}
	return false;
};
export const projectToName = function(p: any) { return p!=null ? p.name : ''; };

// Domänen-spezifische Feld-Definitionen (Bohrpunkte)
export const Values: any = {
	"Aufnahmedatum": { "type": "date", "accessor": "header.aufnahme.datum" },
	"Aufnahmetiefe": { "type": "number", "accessor": "header.aufnahme.tiefe" },
	"Baumart": { "type": "string", "accessor": "extendedHeader.baumarten", "array": true, "anyOf": anyOfBaumarten, "anyOfName": "anyOfBaumarten" },
	"Begründungsart": { "type": "string", "accessor": "extendedHeader.begruendungsart" },
	"Bestockungstyp": { "type": "string", "accessor": "extendedHeader.bestockungsTyp", "convert": altNeuConverter },
	"Entwässerungsverhalten": { "type": "string", "accessor": "extendedHeader.entwaesserungsverhalten" },
	"Feinbodenform": { "type": "string", "accessor": "header.bodenform", "convert": fbfToString },
	"Forstabteilung": { "type": "number", "accessor": "header.adresse.abteilung", "convert": stringToNumber },
	"Forstadresse": { "type": "string", "accessor": "header.adresse", "convert": forstadresseToString },
	"Forstamt": { "type": "string", "accessor": "header.forstamt" },
	"Forstbetrieb": { "type": "string", "accessor": "header.forstbetrieb" },
	"G-Horizont(G)": { "type": "string", "accessor": "extendedHeader.gHorizont.g" },
	"G-Horizont(Go)": { "type": "string", "accessor": "extendedHeader.gHorizont.go" },
	"G-Horizont(Gr)": { "type": "string", "accessor": "extendedHeader.gHorizont.gr" },
	"Geologie": { "type": "string", "accessor": "extendedHeader.geologie", "convert": geologieToString },
	"Grundwasserform": { "type": "string", "accessor": "header.wasserstufe" },
	"Hangneigung": { "type": "number", "accessor": "extendedHeader.hangneigung" },
	"Hangrichtung": { "type": "string", "accessor": "extendedHeader.hangrichtung" },
	"Hauptbodenform": { "type": "string", "accessor": "header.bodenform", "convert": hbfToString },
	"Horizonte": { "type": "string", "accessor": "Horizontfolge", "array": true, "anyOf": anyOfHorizonte, "anyOfName": "anyOfHorizonte" },
	"Humusauflage(Of)": { "type": "number", "accessor": "extendedHeader.humusAuflage.of" },
	"Humusauflage(Oh)": { "type": "number", "accessor": "extendedHeader.humusAuflage.oh" },
	"Humusauflage(Ol)": { "type": "number", "accessor": "extendedHeader.humusAuflage.ol" },
	"Humusform": { "type": "string", "accessor": "header.humusform.aufnahmeFlaeche", "convert": altNeuConverter },
	"Karbonat": { "type": "number", "accessor": "extendedHeader.karbonat" },
	"Kartierer": { "type": "string", "accessor": "header.aufnahme.kartierer" },
	"Klimabereich": { "type": "string", "accessor": "extendedHeader.klimabereich" },
	"Klimastufe": { "type": "string", "accessor": "extendedHeader.klimaStufe", "convert": altNeuConverter },
	"kMgCaP-Serie": { "type": "string", "accessor": "extendedHeader.kMgCaPSerie" },
	"Lage": { "type": "string", "accessor": "extendedHeader.lage" },
	"Meereshöhe": { "type": "number", "accessor": "extendedHeader.meereshoehe" },
	"Mesoklima": { "type": "string", "accessor": "extendedHeader.mesoklima" },
	"Mesorelief": { "type": "string", "accessor": "extendedHeader.mesorelief" },
	"Mischform": { "type": "string", "accessor": "extendedHeader.mischform" },
	"Moormächtigkeit": { "type": "number", "accessor": "header.moorMaechtigkeit" },
	"Morphologie": { "type": "string", "accessor": "extendedHeader.morphologie", "array": true },
	"Nummer": { "type": "string", "accessor": "header.nummer" },
	"nWsk": { "type": "number", "accessor": "extendedHeader.nWsk" },
	"nWsk-Stufe": { "type": "string", "accessor": "extendedHeader.nWskStufe" },
	"pH-Wert 1": { "type": "number", "accessor": "extendedHeader.ph.wert1" },
	"pH-Wert 2": { "type": "number", "accessor": "extendedHeader.ph.wert2" },
	"Projekt": { "type": "string", "accessor": "header.projects", "array": true, "anyOf": anyOfProjects, "anyOfName": "anyOfProjects" },
	"Punkttyp": { "type": "string", "accessor": "type", "convert": punktartTypeNormalize, "convertArg": true, "pickerLabel": punktartDisplayLabel, "valueHint": punktartBeschreibung },
	"Relief": { "type": "string", "accessor": "extendedHeader.relief.relief" },
	"Revier": { "type": "string", "accessor": "header.revier" },
	"S-Horizont(S)": { "type": "string", "accessor": "extendedHeader.sHorizont.s" },
	"S-Horizont(Sd)": { "type": "string", "accessor": "extendedHeader.sHorizont.sd" },
	"S-Horizont(Sw)": { "type": "string", "accessor": "extendedHeader.sHorizont.sw" },
	"Saugsaum": { "type": "number", "accessor": "extendedHeader.saugsaum" },
	"Spiegeltiefe": { "type": "number", "accessor": "extendedHeader.spiegelTiefe" },
	"Stauwasserform": { "type": "string", "accessor": "header.wasserstufe2" },
	"STFG": { "type": "string", "accessor": "", "convert": stfgString },
	"Substrat:Festigkeit": { "type": "number", "accessor": "Substratfolge", "array": true, "anyOf": anyOfSubstrate, "anyOfName": "anyOfSubstrate", "convert": substratToFestigkeit },
	"Substrat:Humusgehalt": { "type": "number", "accessor": "Substratfolge", "array": true, "anyOf": anyOfSubstrate, "anyOfName": "anyOfSubstrate", "convert": substratToHumusgehalt },
	"Substrat:Karbonatgehalt": { "type": "number", "accessor": "Substratfolge", "array": true, "anyOf": anyOfSubstrate, "anyOfName": "anyOfSubstrate", "convert": substratToKarbonatgehalt },
	"Substrat:Lagerungsdichte": { "type": "number", "accessor": "Substratfolge", "array": true, "anyOf": anyOfSubstrate, "anyOfName": "anyOfSubstrate", "convert": substratToLagerungsdichte },
	"Substrat:nWSK": { "type": "number", "accessor": "Substratfolge", "array": true, "anyOf": anyOfSubstrate, "anyOfName": "anyOfSubstrate", "convert": substratToNWSK },
	"Substrat:Skelettgehalt": { "type": "number", "accessor": "Substratfolge", "array": true, "anyOf": anyOfSubstrate, "anyOfName": "anyOfSubstrate", "convert": substratToSkelettgehalt },
	"Substratfeuchte": { "type": "string", "accessor": "header.substratFeuchte" },
	"Substratfolge": { "type": "string", "accessor": "Substratfolge", "array": true, "anyOf": anyOfSubstrate, "anyOfName": "anyOfSubstrate", "convert": substratToName },
	"V-Wert": { "type": "string", "accessor": "extendedHeader.vWertSaugsaum" },
	"Vegetation": { "type": "string", "accessor": "bodenvegetation.aufnahme.vegetationen", "array": true, "anyOf": anyOfVegetationen, "anyOfName": "anyOfVegetationen" },
	"Vegetationsformengruppe": { "type": "string", "accessor": "header.vegetationsformengruppe" },
	"Waldfunktion": { "type": "string", "accessor": "extendedHeader.waldfunktion" },
	"Witterung": { "type": "string", "accessor": "extendedHeader.witterung" },
	"Wuchsbezirk": { "type": "string", "accessor": "extendedHeader.wuchsbezirk" },
	"Workflow-Status": { "type": "string", "accessor": "workflow.status", "options": ["bearbeitung", "kontrolle", "in_pruefung", "abgeschlossen", "abgelehnt"] },
};

// Condition mit domänen-spezifischen Values konfigurieren
Condition.configure(Values);

// -----------------------------------------------------------------------------
// Value-Extractors: gegenstück zu anyOf*-Funktionen.
// Sammeln die Werte aus einem Doc-Feld (statt zu matchen) und liefern sie
// als Array zurück — wird für die "Vorhandene Werte"-Vorschau im Filter genutzt.
// -----------------------------------------------------------------------------

export type ValueExtractor = (raw: any, convert?: (x: any) => any) => any[];

const applyConvert = (v: any, convert?: (x: any) => any) => {
	const c = convert ? convert(v) : v;
	return c == null || c === '' ? null : c;
};

export const valuesOfBaumarten: ValueExtractor = (raw, convert) => {
	if (raw == null) return [];
	if (typeof raw === 'string') {
		const c = applyConvert(raw, convert);
		return c == null ? [] : [c];
	}
	if (!Array.isArray(raw)) return [];
	const out: any[] = [];
	for (const x of raw) {
		const c = applyConvert(x, convert);
		if (c != null) out.push(c);
	}
	return out;
};

export const valuesOfVegetationen: ValueExtractor = (raw, convert) => {
	if (!Array.isArray(raw)) return [];
	const out: any[] = [];
	for (const auf of raw) {
		if (auf?.vegetation != null) {
			const c = applyConvert(auf.vegetation, convert);
			if (c != null) out.push(c);
		}
		if (Array.isArray(auf?.vegetationen)) {
			for (const el of auf.vegetationen) {
				if (el?.vegetation != null) {
					const c = applyConvert(el.vegetation, convert);
					if (c != null) out.push(c);
				}
			}
		}
	}
	return out;
};

export const valuesOfHorizonte: ValueExtractor = (raw, convert) => {
	if (!Array.isArray(raw)) return [];
	const out: any[] = [];
	for (const hor of raw) {
		if (!hor || !Array.isArray(hor.horizonte)) continue;
		for (const h of hor.horizonte) {
			if (h == null) continue;
			const c = applyConvert(h, convert);
			if (c != null) out.push(c);
		}
	}
	return out;
};

export const valuesOfSubstrate: ValueExtractor = (raw, convert) => {
	if (!Array.isArray(raw)) return [];
	const out: any[] = [];
	for (const s of raw) {
		if (s == null) continue;
		const c = applyConvert(s, convert);
		if (c != null) out.push(c);
	}
	return out;
};

export const valuesOfProjects: ValueExtractor = (raw, convert) => {
	if (!Array.isArray(raw)) return [];
	const out: any[] = [];
	for (const p of raw) {
		if (p?.name == null) continue;
		const c = applyConvert(p.name, convert);
		if (c != null) out.push(c);
	}
	return out;
};

// Map von anyOfName → Extractor. FilterService sucht hier nach, wenn ein Feld
// `array: true` und einen `anyOfName` hat.
export const ValueExtractors: Record<string, ValueExtractor> = {
	anyOfBaumarten: valuesOfBaumarten,
	anyOfVegetationen: valuesOfVegetationen,
	anyOfHorizonte: valuesOfHorizonte,
	anyOfSubstrate: valuesOfSubstrate,
	anyOfProjects: valuesOfProjects,
};
